import axios from 'axios'

export const S3PAY_FUNCTIONS_BASE = 'https://asia-east2-connextcc.cloudfunctions.net'

export function normalizeS3PayVisibleCodes (value) {
  const values = Array.isArray(value) ? value : String(value || '').split(',')
  return values
    .map(code => String(code || '').trim().toUpperCase())
    .filter(Boolean)
}

export function isS3PayDepositAvailableForCode (config, userCode) {
  if (!config || config.enabled !== true || config.depositEnabled !== true) return false

  const codes = normalizeS3PayVisibleCodes(config.visibleToCodes)
  const normalizedUserCode = String(userCode || '').trim().toUpperCase()
  return codes.includes('*') || Boolean(normalizedUserCode && codes.includes(normalizedUserCode))
}

export async function fetchS3PayPublicConfig () {
  const response = await axios.get(`${S3PAY_FUNCTIONS_BASE}/s3PayPublicConfig`, { timeout: 10000 })
  const payload = response && response.data
  if (!payload || !payload.success || !payload.data) {
    throw new Error('S3Pay public config response ไม่ถูกต้อง')
  }
  return payload.data
}
